/* eslint-disable */
const mutations = {
  loginUser(state, { user, token }) {
    state.user = user;
    state.token = token;
  },

  logoutUser(state) {
    state.user = {};
    state.token = '';
  },

  updateUserName(state, { name }) {
    state.user = {
      ...state.user,
      name,
    };
  },

  updateToken(state, { token }) {
    state.token = token;
  },
};

export default mutations;
